import React from 'react'
import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'

const messageCss = css`
  display: grid;
  grid-template-columns: min-content max-content;
  align-items: center;
  margin: 40px auto;
  grid-column-gap: 12px;
  width: max-content;
`

export default function LoadingPage(): JSX.Element {
  return (
    <div css={messageCss} data-testid="loading">
      <NoticeLoading size="lg" />
    </div>
  )
}
